import { backgroundOrange, blackOrange, textMuted } from '@/theme/colors'
import { fontBody } from '@/theme/fonts'
import styled from 'styled-components'

/**
 * Cream, full-height scroll surface every public `/shared/trips/...` page sits
 * on — the overview, the itinerary, and the five per-section detail pages all
 * share this one background so the public tree reads as a single standalone
 * (no app Layout) marketing view. Also wraps the loading / unavailable / error
 * states, which render on the bare surface without the header chrome.
 */
export const Page = styled.div`
	flex: 1;
	min-height: 0;
	width: 100%;
	overflow-y: auto;
	display: flex;
	flex-direction: column;
	background: ${backgroundOrange};
	color: ${blackOrange};
`

export const FooterCaption = styled.footer`
	text-align: center;
	padding: 24px 0 40px;
	font-family: ${fontBody};
	font-size: 13px;
	color: ${textMuted};
`
